var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "over_layout" },
    [
      _c("section", { staticClass: "upgrade" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$store.commit("paymentModal", true)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "setting_block" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "block" }, [
            _c("div", { staticClass: "image_left" }, [
              _c("div", { staticClass: "user_img" }, [
                _c("img", {
                  attrs: {
                    src: _vm.$store.getters.user.avatar
                      ? _vm.$store.getters.user.avatar.image
                      : _vm.$store.getters.user.photo
                  },
                  on: {
                    click: function($event) {
                      return _vm.$store.commit("uploadPhoto", true)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "fields" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "input_type" }, [
                  _c("div", {
                    staticClass: "edit_pane",
                    on: { click: _vm.switchClick }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:3",
                        expression: "'required|min:3'"
                      }
                    ],
                    staticClass: "inp_text",
                    class: _vm.errors.first("name") ? "invalid" : "",
                    attrs: {
                      name: "name",
                      disabled: "",
                      placeholder: _vm.$store.getters.t("name"),
                      type: "text"
                    },
                    domProps: { value: _vm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input_type" }, [
                  _c("div", {
                    staticClass: "edit_pane",
                    on: { click: _vm.switchClick }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.surname,
                        expression: "surname"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:3",
                        expression: "'required|min:3'"
                      }
                    ],
                    staticClass: "inp_text",
                    class: _vm.errors.first("surname") ? "invalid" : "",
                    attrs: {
                      name: "surname",
                      disabled: "",
                      placeholder: _vm.$store.getters.t("surname"),
                      type: "text"
                    },
                    domProps: { value: _vm.surname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.surname = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input_type" }, [
                  !_vm.$store.getters.user.email_verified_at
                    ? _c("div", {
                        staticClass: "edit_pane",
                        on: { click: _vm.switchClick }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "inp_text",
                    class: _vm.errors.first("email") ? "invalid" : "",
                    attrs: {
                      name: "email",
                      disabled: "",
                      placeholder: _vm.$store.getters.t("email"),
                      type: "email"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input_type" }, [
                  _c("input", {
                    staticClass: "submit change-password",
                    attrs: { type: "submit" },
                    domProps: {
                      value: _vm.$store.getters.t("change_password")
                    },
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("changePassword", true)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.$store.getters.is("Support") ||
                _vm.$store.getters.is("Admin")
                  ? _c("div", { staticClass: "input_type" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "submit change-password dashboard-button",
                          attrs: {
                            href: "/" + _vm.$store.getters.locale + "/admin"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$store.getters.t("dashboard")))]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "logout" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#logout" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$store.getters.t("logout")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "full_info" },
              [
                _vm.$store.getters.user.active_tariff.length > 0
                  ? [
                      _c("div", { staticClass: "circles" }, [
                        _c("div", { staticClass: "circle" }, [
                          _c("div", { staticClass: "days" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$store.getters.user.active_tariff[0].days.d
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$store.getters.t("day")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "circle" }, [
                          _c("div", { staticClass: "days" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$store.getters.user.active_tariff[0].days.h
                              ) + " "
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$store.getters.t("hour")))
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tariff_name",
                          class: _vm.$store.getters.user.active_tariff[0].style
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$store.getters.user.active_tariff[0]
                                  .display_name
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "all_title_block" }, [
                  _c("div", { staticClass: "title_block" }, [
                    _c("div"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$store.getters.t("Last_edited")) + " ")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "last_resume",
                    staticStyle: { position: "relative" }
                  },
                  [
                    _vm._l(_vm.cvs, function(cv, index) {
                      return _c(
                        "div",
                        { key: index + "-cv" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "cv-show-" + cv.type,
                                  params: {
                                    lang: _vm.$store.getters.locale,
                                    cv: cv.id
                                  }
                                },
                                title: "cv - " + cv.id
                              }
                            },
                            [
                              cv.status_generate
                                ? _c("img", {
                                    attrs: {
                                      src: cv.filename
                                        ? "/uploads/cv/" + cv.filename + ".png"
                                        : "/uploads/cv/cv_img_" + cv.id + ".png"
                                    }
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass: "loader loader--style1",
                                      staticStyle: { "margin-top": "128px" },
                                      attrs: { title: "0" }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            version: "1.1",
                                            id: "loader-1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                            x: "0px",
                                            y: "0px",
                                            width: "100px",
                                            height: "100px",
                                            viewBox: "0 0 40 40",
                                            "enable-background":
                                              "new 0 0 40 40",
                                            "xml:space": "preserve"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              opacity: "0.2",
                                              fill: "#000",
                                              d:
                                                "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n                            s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n                            c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "path",
                                            {
                                              attrs: {
                                                fill: "#000",
                                                d:
                                                  "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n                            C22.32,8.481,24.301,9.057,26.013,10.047z"
                                              }
                                            },
                                            [
                                              _c("animateTransform", {
                                                attrs: {
                                                  attributeType: "xml",
                                                  attributeName: "transform",
                                                  type: "rotate",
                                                  from: "0 20 20",
                                                  to: "360 20 20",
                                                  dur: "0.5s",
                                                  repeatCount: "indefinite"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "add_circle_div" }, [
                      _c("div", {
                        staticClass: "add_circle",
                        on: {
                          click: function($event) {
                            return _vm.openPaymentModal()
                          }
                        }
                      })
                    ])
                  ],
                  2
                )
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.$store.getters.uploadPhoto
        ? _c("avatar-editor", {
            attrs: {
              image: _vm.$store.getters.user.photo
                ? _vm.$store.getters.user.photo
                : "/vue/images/user_img.jpg",
              dataUrl: "/api/user/image/change"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.changePassword ? _c("change-password") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img_load" }, [
      _c("label", [
        _c("div", { staticClass: "attach__up" }),
        _vm._v(" "),
        _c("input", { staticClass: "attach_input", attrs: { type: "file" } })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b555a1ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b555a1ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/profile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b555a1ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/profile.vue
// module chunks = 0